/**
 * DashboardLoader — composants de chargement unifiés (DA 2026)
 *
 * PageSkeleton  → chargement page entière (skeleton layout preview)
 * PageSpinner   → spinner centré pour les cas simples
 * ButtonSpinner → spinner inline dans les boutons / actions
 */

/** Skeleton page complète — remplace tous les if(loading) dans les pages dashboard */
export function PageSkeleton({ rows = 5, cards = 4 }) {
  return (
    <div className="p-6 animate-pulse">
      {/* En-tête */}
      <div className="mb-8">
        <div className="h-7 bg-neutral-100 rounded-lg w-44 mb-2" />
        <div className="h-4 bg-neutral-100 rounded w-64" />
      </div>

      {/* Stat cards */}
      <div className={`grid grid-cols-2 lg:grid-cols-${cards} gap-4 mb-8`}>
        {[...Array(cards)].map((_, i) => (
          <div key={i} className="h-28 bg-neutral-100 rounded-xl" />
        ))}
      </div>

      {/* Table / liste */}
      <div className="bg-white rounded-xl border border-neutral-100 overflow-hidden">
        {/* Header */}
        <div className="h-12 bg-neutral-50 border-b border-neutral-100 px-4 flex items-center gap-6">
          {[...Array(4)].map((_, i) => (
            <div key={i} className="h-3 bg-neutral-100 rounded w-20" />
          ))}
        </div>
        {/* Rows */}
        {[...Array(rows)].map((_, i) => (
          <div
            key={i}
            className="h-14 border-b border-neutral-50 px-4 flex items-center gap-6"
          >
            <div className="h-8 w-8 bg-neutral-100 rounded-full flex-shrink-0" />
            <div className="h-3 bg-neutral-100 rounded flex-1 max-w-[180px]" />
            <div className="h-3 bg-neutral-100 rounded flex-1 max-w-[120px]" />
            <div className="h-3 bg-neutral-100 rounded w-20 ml-auto" />
            <div className="h-6 w-16 bg-neutral-100 rounded-full" />
          </div>
        ))}
      </div>
    </div>
  );
}

/** Spinner centré — pour les sections qui ne méritent pas un skeleton complet */
export function PageSpinner({ minHeight = 'h-64' }) {
  return (
    <div className={`flex items-center justify-center ${minHeight}`}>
      <div className="relative h-10 w-10">
        {/* Track */}
        <div className="absolute inset-0 rounded-full border-2 border-neutral-100" />
        {/* Arc animé — couleur primaire Namke */}
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-[#054625] animate-spin" />
      </div>
    </div>
  );
}

/** Spinner tiny pour les boutons et actions inline */
export function ButtonSpinner({ className = '' }) {
  return (
    <span
      className={`inline-block h-4 w-4 rounded-full border-2 border-current border-t-transparent animate-spin ${className}`}
    />
  );
}

export default PageSkeleton;
